import { onMounted, onBeforeUnmount } from 'vue';

/**
 * останавливается автоматически
 * @param cb - колбэк
 */
export const useResize = (cbRaw) => {

    const cb = () => window.requestAnimationFrame(() => {
        if (typeof cbRaw === 'function') cbRaw();
    });

    onMounted(() => {
        cb();
        window.addEventListener('resize', cb, { passive: true });

        screen?.orientation?.addEventListener('change', cb, { passive: true });
    });

    onBeforeUnmount(() => {
        window.removeEventListener('resize', cb, { passive: true });

        screen?.orientation?.removeEventListener('change', cb, { passive: true });
    });
};
